<template>
    <ModalBase
        :name="name"
        :title="title"
        :subtitle="subtitle"
        @close="handleClose"
        @opened="emit('opened')"
        @closed="emit('closed')"
    >
        <slot></slot>

        <template v-if="$slots.footer" #footer>
            <slot name="footer"></slot>
        </template>
    </ModalBase>
</template>

<script setup>
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';

    defineProps({
        name: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: '',
        },
    });

    const emit = defineEmits(['close', 'opened', 'closed']);

    function handleClose() {
        emit('close');
    }
</script>
